import React, {
  useCallback,
  useEffect,
  useState,
  Fragment,
  useContext,
} from "react";
import clienteAxios from "../../../config/axios";
import SpinNormal from "../../../components/Spin/spinNormal";
import Error500 from "../../error500";
import { DashboardContext } from "../../../context/dashboar_context";
import {
  Box,
  Checkbox,
  Collapse,
  Divider,
  Grid2 as Grid,
  IconButton,
  LinearProgress,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  Menu,
  MenuItem,
  Paper,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import {
  ExpandLess,
  ExpandMore,
  FolderOpen,
  InsertDriveFileOutlined,
  Link as LinkIcon,
} from "@mui/icons-material";
import useSWR, { mutate } from "swr";

const fetcher = (url, token) =>
  clienteAxios
    .get(url, {
      headers: { Authorization: `bearer ${token}` },
    })
    .then((res) => res.data);

export default function ListaContenido({ curso, props, idCourse, slug }) {
  const theme = useTheme();
  const [lista, setLista] = useState([]);
  //const [loading, setLoading] = useState(false);
  //const [error, setError] = useState("");
  const { setTopics, update, progreso } = useContext(DashboardContext);
  let user = { _id: "" };
  const token = localStorage.getItem("token");
  if (token !== null) user = JSON.parse(localStorage.getItem("student"));

  /* const obtenerListaBD = useCallback(async () => {
    if (!user._id || !curso.course._id) return;
    setLoading(true);
    await clienteAxios
      .get(`/course/datalist/${curso.course._id}/user/${user._id}`, {
        headers: {
          Authorization: `bearer ${token}`,
        },
      })
      .then((res) => {
        setLoading(false);
        setLista(res.data);

        const allTopics = [];

        res.data.forEach((block) => {
          block.topics.forEach((topic) => {
            allTopics.push(topic);
          });
        });
        console.log("allTopics::", allTopics, res.data)
        setTopics(allTopics);
      })
      .catch((err) => {
        setLoading(false);
        if (err.response) {
          setError(err.response.data.message);
        } else {
          setError("Al parecer no se a podido conectar al servidor.");
        }
      });
  }, [token, user._id, curso.course._id, setTopics]); */

  const endpoint = `/course/datalist/${curso.course._id}/user/${user?._id}`;

  const { data, error, isLoading } = useSWR(
    [endpoint, token],
    ([url, token]) => fetcher(url, token),
    { revalidateOnFocus: false, revalidateIfStale: false },
  );

  useEffect(() => {
    console.log("update::", update);
    mutate([endpoint, token]);
  }, [update, endpoint, token]);

  useEffect(() => {
    if (data) {
      setLista(data);
      const allTopics = [];
      data.forEach((block) => {
        block.topics.forEach((topic) => {
          allTopics.push(topic);
        });
      });
      setTopics(allTopics);
    }
  }, [data, setTopics, update]);

  if (lista.length === 0 && !curso.endTopicView) {
    return (
      <Box
        minHeight="80vh"
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <Typography variant="h4">Aun no hay bloques</Typography>
      </Box>
    );
  }

  console.log("lista::", lista);

  if (lista.length === 0) {
    if (isLoading) {
      return (
        <Box
          sx={{
            minHeight: "80vh",
            minWidth: 400,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <SpinNormal />
        </Box>
      );
    } else {
      return <Error500 error={error} />;
    }
  }

  const render_blocks = lista.map((bloque, index) => (
    <ListaBloques key={index} bloque={bloque} curso={curso} props={props} />
  ));

  return (
    <Box
      sx={{
        [theme.breakpoints.down("sm")]: {
          height: "45vh",
        },
        width: { md: 400 },
      }}
    >
      <Box mt={1}>
        <Typography align="center">
          <b>Avance del curso</b>
        </Typography>
      </Box>
      <Box display="flex" alignItems="center">
        <Box width="100%" m={1}>
          <LinearProgress variant="determinate" value={parseInt(progreso)} />
        </Box>
        <Box minWidth={35}>
          <Tooltip
            disableFocusListener
            disableTouchListener
            title="Progreso del curso"
            arrow
            placement="top"
          >
            <Typography
              variant="body2"
              color="textSecondary"
            >{`${progreso}%`}</Typography>
          </Tooltip>
        </Box>
      </Box>
      <Divider />
      {render_blocks}
    </Box>
  );
}

const ListaBloques = ({ bloque, curso, props }) => {
  const block = bloque.block;
  const temas = bloque.topics;
  let user = { _id: "" };
  const token = localStorage.getItem("token");
  const [open, setOpen] = useState(false);
  const [newTemas, setNewTemas] = useState(false);
  const {
    setTemaActual,
    topics,
    endTopic,
    setEndTopic,
    action,
    setAction,
    update,
    setUpdate,
    setProgreso,
  } = useContext(DashboardContext);

  if (token !== null) user = JSON.parse(localStorage.getItem("student"));

  const handleClick = () => setOpen(!open);
  const handleToggle = async (value, topic) => {
    if (topic.keyTopicVideo) return;
    await clienteAxios
      .post(
        `/course/complete/topic/`,
        {
          idCourse: curso.course._id,
          idTopic: topic._id,
          idUser: user?._id,
          public: value,
        },
        {
          headers: {
            Authorization: `bearer ${token}`,
          },
        },
      )
      .then((res) => {
        setUpdate(!update);
        // console.log(res);
        if (
          user.rol === "Estudiante" &&
          parseFloat(res.data.message) >= 50 &&
          (!curso.inscriptionStudent.questionUniline ||
            curso.inscriptionStudent.questionUniline === false)
        ) {
          props.history.push(
            `/question-curse-uniline/${curso.course._id}/curso/${curso.course.slug}`,
          );
        }
        setProgreso(res.data.message);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const ponerTemaActual = useCallback(
    (topicSelected) => {
      if (topicSelected) {
        topics.forEach((topic, index) => {
          if (topic._id === topicSelected._id) {
            setAction(1);
            setTemaActual({
              id: topics[index]._id,
              video: topics[index].keyTopicVideo,
              index: index,
              tema: topic,
            });
            setEndTopic(
              topics.length === index + 1
                ? topics[index]._id
                : topics[index + 1]._id,
            );
            setOpen(true);
          }
        });
      } else {
        topics.forEach((topic, index) => {
          if (
            topic.topicCompleted.length > 0 &&
            topic._id === endTopic &&
            action === 0
          ) {
            setAction(1);
            setTemaActual({
              id:
                topics.length === index + 1
                  ? topics[index]._id
                  : topics[index]._id,
              video:
                topics.length === index + 1
                  ? topics[index].keyTopicVideo
                  : topics[index].keyTopicVideo,
              index: topics.length === index + 1 ? index : index,
              tema: topic,
            });
            setEndTopic(
              topics.length === index + 1
                ? topics[index]._id
                : topics[index + 1]._id,
            );
            setOpen(true);
          } else {
            if (
              topic.topicCompleted.length === 0 &&
              topic._id === endTopic &&
              action === 0
            ) {
              setAction(1);
              setTemaActual({
                id: topic._id,
                video: topic.keyTopicVideo,
                index: index,
                tema: topic,
              });
              setEndTopic(
                topics.length === index + 1
                  ? topics[index]._id
                  : topics[index + 1]._id,
              );
              setOpen(true);
            }
          }
        });
      }
    },
    [setTemaActual, endTopic, setEndTopic, action, setAction, topics],
  );

  const temasNuevos = useCallback(async () => {
    for (let i = 0; i < temas.length; i++) {
      if (temas[i]?.newTopic === true) {
        return setNewTemas(true);
      }
    }
  }, [temas]);

  const render_topics = temas.map((topic) => (
    <TopicRender
      topic={topic}
      key={topic._id}
      handleToggle={handleToggle}
      ponerTemaActual={ponerTemaActual}
    />
  ));

  useEffect(() => {
    temasNuevos();
    ponerTemaActual();
  }, [ponerTemaActual, temasNuevos]);

  return (
    <>
      <List>
        <ListItem button onClick={handleClick} sx={{ cursor: "pointer" }}>
          <ListItemText primary={block.blockTitle} />
          {newTemas === true ? (
            <Paper elevation={3} style={{ background: "#ec4b53" }}>
              <Box
                style={{ color: "White" }}
                p={1}
                display="flex"
                textAlign="center"
                alignContent="center"
                alignItems="center"
              >
                Nuevo
              </Box>
            </Paper>
          ) : null}
          {open ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {render_topics}
          </List>
        </Collapse>
      </List>
      <Divider />
    </>
  );
};

const StyledMenu = (props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "center",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "center",
    }}
    sx={{
      "& .MuiPaper-root": {
        border: "1px solid #d3d4d5",
        // width: 210, // Descomentar si lo necesitas
        // maxWidth: 300, // Descomentar si lo necesitas
      },
    }}
    {...props}
  />
);

const TopicRender = ({ topic, handleToggle, ponerTemaActual }) => {
  const theme = useTheme();
  const labelId = `checkbox-list-secondary-label-${topic._id}`;
  const [anchorEl, setAnchorEl] = useState(null);
  const { temaActual } = useContext(DashboardContext);

  const handleClickMenu = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = (event) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  return (
    <Fragment>
      <Grid container alignItems="center" key={topic._id}>
        <Grid size={{ lg: 1, xs: 1 }}>
          <Checkbox
            edge="end"
            onClick={() =>
              topic.topicCompleted.length === 0
                ? handleToggle(true, topic)
                : handleToggle(false, topic)
            }
            disableFocusRipple
            disableTouchRipple
            disableRipple
            checked={topic.topicCompleted.length > 0}
            inputProps={{ "aria-labelledby": labelId }}
            style={{ color: "rgb(60,0,142)" }}
          />
        </Grid>
        <Grid size={{ lg: 9, xs: 9 }}>
          <ListItem
            sx={{ cursor: "pointer" }}
            button
            style={{
              backgroundColor:
                topic._id === temaActual.id
                  ? theme.palette.background.selected
                  : null,
            }}
            onClick={() => {
              ponerTemaActual(topic);
            }}
          >
            <ListItemText id={labelId} primary={topic.topicTitle} />

            {topic.resources.length > 0 ? (
              <Fragment>
                <ListItemSecondaryAction>
                  <IconButton edge="end" onClick={(e) => handleClickMenu(e)}>
                    <FolderOpen />
                  </IconButton>
                </ListItemSecondaryAction>
                <StyledMenu
                  disableScrollLock={true}
                  id={`customized-menu-${topic._id}`}
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleCloseMenu}
                >
                  {topic.resources.length > 0 ? (
                    topic.resources.map((recurso, index) => {
                      // console.log(topic.resources);
                      return recurso.urlExtern ? (
                        <Link
                          key={recurso._id}
                          target="_blank"
                          rel="noopener"
                          href={recurso.urlExtern}
                        >
                          <MenuItem dense>
                            <ListItemIcon>
                              <LinkIcon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText primary={recurso.title} />
                          </MenuItem>
                        </Link>
                      ) : (
                        <Link
                          key={recurso._id}
                          href={recurso.urlDownloadResource}
                          download={recurso.title}
                        >
                          <MenuItem dense>
                            <ListItemIcon>
                              <InsertDriveFileOutlined fontSize="small" />
                            </ListItemIcon>
                            <ListItemText primary={recurso.title} />
                          </MenuItem>
                        </Link>
                      );
                    })
                  ) : (
                    <div />
                  )}
                </StyledMenu>
              </Fragment>
            ) : (
              <div />
            )}
          </ListItem>
        </Grid>
        {topic.newTopic === true ? (
          <Grid size={{ lg: 2, xs: 2 }}>
            <Fragment>
              <Paper elevation={3} style={{ background: "#ec4b53" }}>
                <Box style={{ color: "White" }} p={1} textAlign="center">
                  Nuevo
                </Box>
              </Paper>
            </Fragment>
          </Grid>
        ) : null}
      </Grid>
    </Fragment>
  );
};
